import upperFirst from 'lodash/upperFirst'
import { compose, withState, lifecycle, setDisplayName } from 'recompose'
import withStatus from 'hocs/bases/withStatus'

const withFetchResources = ({
  resourceName = 'resources',
  getInitialResources = () => ([]),
  getAction = () => Promise.resolve,
  getSuccessData = ({ data }) => data,
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    setDisplayName(ResourceName),
    withState(resourceName, 'setResources', getInitialResources),
    withStatus({
      actionName: `fetch${ResourceName}`,
      statusName: `fetch${ResourceName}Status`,
      getAction,
      getRequestMessage: () => `Searching for ${ResourceName}...`,
      getOnSuccess: (props) => (data) => props.setResources(getSuccessData(data)),
    }),
    lifecycle({
      componentDidMount() {
        this.props[`fetch${ResourceName}`]()
      },
    })
  )
}

export default withFetchResources


// WEBPACK FOOTER //
// ./src/hocs/bases/withFetchResources.js